'use client';

import * as React from 'react';

import { ResourceBadge } from '@/components/ui/resource-badge';
import { formatMoney } from "@/lib/money";
import { useStoreNavigate } from '@/hooks/use-app-navigate';

interface ProductResourceBadgeProps {
  productId: string;
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
  className?: string;
}

/**
 * PaymentResourceBadge component for displaying payment information
 * Inherits from generic ResourceBadge
 */
export function ProductResourceBadge({
  productId,
  variant = 'secondary',
  className,
}: ProductResourceBadgeProps) {
  const { storeRoutes } = useStoreNavigate();
  // Format display value based on available data
  const displayValue = React.useMemo(() => {
    return `${productId.substring(0, 8)}...`;
  }, [productId]);

  return (
    <ResourceBadge
      name="variant"
      value={displayValue}
      appLink={storeRoutes.PRODUCT_DETAILS(productId)}
      variant={variant}
      className={className}
    />
  );
}
